import axios from "@/api/axiosInstance";

export function fetchSmsPrices() {
  return axios.get(`/api/v1/sms`);
}
